import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import AuthShell from "@/components/shared/AuthShell";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("Se o email existir, enviamos um link de recuperação.");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Recuperar senha"
      subtitle="Enviaremos um link de redefinição para o seu email."
      footer={<p className="text-sm text-center text-muted-foreground"><Link to="/login" className="text-primary hover:underline">Voltar ao login</Link></p>}
    >
      {sent ? (
        <div className="rounded-lg border border-border p-4 text-sm text-muted-foreground">
          Verifique seu email. O link expira em 1 hora. (Em modo de desenvolvimento, o link é exibido nos logs do servidor.)
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email" />
          </div>
          <Button type="submit" className="w-full" disabled={loading} data-testid="forgot-submit">
            {loading ? "…" : "Enviar link"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
